module.exports = __webpack_public_path__ + "img/zespol2.d96d53c1.avif";